import {
    GET_HOME_CONTENT,

} from '../actions/types';

const initialState = {
    contents: []
};

function contentHomeReducer(state = initialState, action) {
    switch (action.type) {
        case GET_HOME_CONTENT:
            return {
                ...state,
                contents: action.payload
            };
        default:
            return state;
    }
}

export default contentHomeReducer;
